module.exports = __webpack_public_path__ + "static/ambasador_czyzewska-4df9373cdf6f531683882d2b06d859fb.png";